import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Article.css";
import NavComplete from "../Component/Navbar1";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Alert from "react-bootstrap/Alert";
import Footer from "../Component/footer";
import Card from "react-bootstrap/Card";
import LoadingImage from "../Component/Loadingimage";
import { useRef } from "react";
// {localStorage.getItem("bahasa") === "ing"?``:``}

const Article5 = () => {
  const handleCardClick = (link) => {
    window.location.href = `${link}`;
  };
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);
  const section6 = useRef(null);

  const scrollToPromo = (ref) => {
    const navbarHeight = 88; // Replace with the actual height of your navigation bar
    const rect = ref.current.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetOffset = rect.top + scrollTop - navbarHeight;

    window.scrollTo({
      top: targetOffset,
      behavior: "smooth",
    });
  };
  const togglescroll1 = () => {
    scrollToPromo(section1);
  };
  const togglescroll2 = () => {
    scrollToPromo(section2);
  };
  const togglescroll3 = () => {
    scrollToPromo(section3);
  };
  const togglescroll4 = () => {
    scrollToPromo(section4);
  };
  const togglescroll5 = () => {
    scrollToPromo(section5);
  };
  const togglescroll6 = () => {
    scrollToPromo(section6);
  };
  return (
    <article>
      {" "}
      <div id="containerss">
        <NavComplete />
        <Container
          className="info-page nunito"
          style={{
            color: "white",
            marginTop: "80px",
            marginBottom: "80px",
            maxWidth: "900px",
          }}
        >
          <Breadcrumb>
            <Breadcrumb.Item href="/Informasi">Blog</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {localStorage.getItem("bahasa") === "ing"
                ? `6 Secrets to Maintain Your Car's Interior to Keep it Bright and Dust-Free`
                : `6 Rahasia Merawat Interior Mobil Agar Tidak Kusam dan Berdebu`}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col>
              <h1 className="roleway">
                {localStorage.getItem("bahasa") === "ing"
                  ? `6 Secrets to Maintain Your Car's Interior to Keep it Bright and Dust-Free`
                  : `6 Rahasia Merawat Interior Mobil Agar Tidak Kusam dan Berdebu`}
              </h1>
              <div style={{ marginBottom: "15px", gap: "20px" }}>
                <i style={{ padding: "0px 2px" }} class="bi bi-person"></i>
                <a
                  style={{ padding: "0px 5px", marginRight: "10px" }}
                  target="blank_"
                  href="https://www.instagram.com/rezzaalviansyah/"
                >
                  Rezza
                </a>
                <i
                  style={{ padding: "0px 2px" }}
                  class="bi bi-calendar4-week"
                ></i>
                <span style={{ padding: "0px 5px" }}>27 November 2023</span>
              </div>
              <img
                src="https://i.ibb.co.com/kgdkfrx/interior.webp"
                alt="stracehs-car"
                className="info-image"
              />
              <Alert
                variant="dark"
                style={{
                  background:
                    "linear-gradient(156deg, rgba(0,0,0,1) 41%, rgba(250,0,8,1) 120%)",
                  color: "white",
                  borderColor: "red",
                }}
                className="gotham"
              >
                <h3 className="gotham">
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Article Content: "
                    : "Isi Artikel: "}
                  {localStorage.getItem("bahasa") === "ing"
                    ? `6 Secrets to Maintain Your Car's Interior to Keep it Bright and Dust-Free`
                    : `6 Rahasia Merawat Interior Mobil Agar Tidak Kusam dan Berdebu`}
                </h3>
                <ul>
                  <li onClick={togglescroll1}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean Up the Trash`
                      : `Bersihkan Sampah`}
                  </li>
                  <li onClick={togglescroll2}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean the Car Dashboard`
                      : `Bersihkan Dashboard Mobil`}
                  </li>
                  <li onClick={togglescroll3}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean Parts of the Interior You Frequently Touch`
                      : `Bersihkan Bagian Interior yang Sering Kamu Sentuh`}
                  </li>
                  <li onClick={togglescroll4}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean the Car Seats`
                      : `Bersihkan Jok Mobil`}
                  </li>
                  <li onClick={togglescroll5}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean the Car Carpets`
                      : `Bersihkan Karpet Mobil`}
                  </li>
                  <li onClick={togglescroll6}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean the Car Door Trim`
                      : `Bersihkan Door Trim Mobil`}
                  </li>
                </ul>
              </Alert>
              <div style={{ textAlign: "start" }}>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `You might have encountered people around you who only care about their external appearance. For example, in terms of clothing, they try to look as eye-catching as possible, complete with makeup on their faces and skincare on their skin. However, often when you visit their rooms, they are messy.`
                    : `Kamu pasti pernah mendapati bahwa ada orang-orang di sekeliling kamu yang hanya peduli dengan tampilan luarnya saja. Misal, dalam hal berpakaian, orang tersebut berusaha tampil se-eye catching mungkin, lengkap dengan make up yang menempel di wajahnya, baluran skin care di kulitnya, tapi tak jarang begitu kamu bertamu ke kamarnya seringkali dalam keadaan berantakan.`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `Usually, this kind of behavior doesn't only occur in terms of appearance but also in maintaining vehicles. You probably like clean, shiny car windows, a sleek body, and a cool-looking dashboard. However, as time passes, dirt and dust make your car look dull and dusty.`
                    : `Biasanya, perilaku yang semacam itu bukan hanya terjadi dalam hal berpenampilan, tapi juga dalam hal merawat kendaraan. Kamu pasti menyukai kaca mobil yang bersih berkilau, body mobil yang licin, dan dashbor yang sejuk dipandang mata. Namun, seiring berjalannya waktu, kotoran dan debu membuat mobil kamu menjadi kusam dan berdebu.`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `Although you may often clean your car, it's almost certain that you don't clean the interior every time you wash it. But don't worry, you don't need to be concerned. We'll show you the secrets to maintaining your car's interior so it doesn't look dull and dusty!`
                    : `Meskipun, mungkin kamu sering membersihkan mobil, tapi hampir bisa dipastikan kalo nggak setiap mencuci mobil bagian interiornya kamu bersihkan juga. Tapi tenang, kamu nggak perlu khawatir. Kami akan menunjukkan rahasia merawat interior mobil milikmu agar tidak kusam dan berdebu!`}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section1}>
                <b>
                  <h2 style={{ marginBottom: "20px" }} className="roleway">
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean Up the Trash`
                      : `Bersihkan Sampah`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/cbtb04c/cleaning-vacum.webp"
                  alt="compoundning-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `A Vacuum Cleaner, also known as a dust extractor, is a cleaning tool that you must have. Its price won't exceed that of your car's interior. Now, before using the vacuum cleaner to suction dust from your car's interior, make sure you dispose of any trash or unwanted items from your cabin.`
                      : `Vacuum Cleaner alias penyedot debu menjadi alat pembersih yang wajib kamu punya. Harganya nggak akan lebih mahal dari interior mobil milikmu. Nah, sebelum menggunakan vacuum cleaner untuk menyedot debu di bagian interior mobil milikmu, pastikan kamu membuang sampah atau barang yang nggak kamu inginkan dari kabinmu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Just a tip for you to always carry several different bags for recyclable items or other trash, so you don't need to sort them again.`
                      : `Sekadar tips untuk kamu agar selalu membawa beberapa tas berbeda untuk barang daur ulang atau sampah lainnya, sehingga kamu nggak perlu memilahnya lagi.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section2}>
                <b>
                  <h2 style={{ marginBottom: "20px" }} className="roleway">
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean the Car Dashboard`
                      : `Bersihkan Dashboard Mobil`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/vVRxT4z/dashboard.webp"
                  alt="Coating-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `If you want to maintain your car dashboard to keep it shiny and not dull, use a special cleaning product. Avoid using household products and scrubbing sponges as they can cause damage.`
                      : `Kalo kamu ingin merawat dashboard mobil agar tetap berkilau dan tidak kusam, gunakan produk pembersih khusus, hindari penggunaan produk rumah tangga dan spons gosok karena dapat merusaknya.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `The infotainment screen can be a bit tricky as it's a frequently touched area. You can use screen wipes or a cloth with soap and water to help clean the screen. Wipe it until dry with a clean cloth. Avoid using harsh chemicals on the infotainment screen as they can damage the anti-glare and anti-fingerprint coatings. Using a microfiber cloth reduces the risk of screen damage.`
                      : `Layar infotainment bisa menjadi sedikit lebih rumit karena merupakan area yang selalu disentuh. Nah, kamu bisa menggunakan tisu layar atau kain dengan sabun dan air untuk membantu membersihkan layar. Lap hingga kering dengan kain bersih. Hindari penggunaan bahan kimia keras pada layar infotainment, karena dapat merusak lapisan anti silau dan anti sidik jari. Menggunakan kain mikrofiber mengurangi risiko kerusakan layar.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section3}>
                <b>
                  <h2 style={{ marginBottom: "20px" }} className="roleway">
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean Parts of the Interior You Frequently Touch`
                      : `Bersihkan Bagian Interior yang Sering Kamu Sentuh`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/Xkp5rX4/handrest.webp"
                  alt="Coating-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Interior parts prone to contamination include the steering wheel, gear stick, dashboard buttons, and touchscreen. You can clean these parts using cleaning wipes or a microfiber cloth.`
                      : `Bagian interior yang rentan terkontaminasi seperti roda kemudi (stir), tongkat persneling, tombol-tombol di dashbor, dan layar sentuh. Bagian-bagian tersebut bisa kamu bersihkan menggunakan tisu pembersih, atau pun lap microfiber.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `If you use a liquid cleaning product, spray it onto a tissue or cloth, not directly onto the interior. Most importantly, do not spray any liquid product to clean the steering wheel, as it can make it slippery!`
                      : `Nah, kalo kamu menggunakan produk pembersih berupa cairan, semprotkan produk tersebut ke tisue, atau kain, jangan langsung ke bagian interiornya. Dan yang terpenting adalah jangan semprotkan produk cairan apapun untuk membersihkan roda kemudi (stir), karena dapat membuatnya licin!.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section4}>
                <b>
                  <h2 style={{ marginBottom: "20px" }} className="roleway">
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean the Car Seats`
                      : `Bersihkan Jok Mobil`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/R9PYj8k/jog-mobil.webp"
                  alt="Coating-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Car seats are also an interior part susceptible to mold and dust contamination. Moreover, it's not uncommon for accidents such as food or drink spills to leave stains on your car seats.`
                      : `Jok mobil juga menjadi interior yang rentan terkontaminasi jamur dan debu. Selain itu, nggak jarang loh musibah berupa ketumpahan makanan dan minuman menyisakan noda pada jok mobil kamu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `But don't worry, you can clean the stains on your car seats using a soft brush. However, if the stains are stubborn, you can spray a special liquid, then brush them afterwards.`
                      : `Tapi tenang, kamu bisa membersihkan noda yang menempel pada jok mobil kamu menggunakan sikat halus. Sementara kalo nodanya membandel, bisa kamu semprotkan cairan khusus, baru kemudian disikat.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section5}>
                <b>
                  <h2 style={{ marginBottom: "20px" }} className="roleway">
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean the Car Carpets`
                      : `Bersihkan Karpet Mobil`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/m54JbRX/carpet-car.webp"
                  alt="Coating-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Like car seats, car carpets also often accumulate stains from food and drink residues. After you've cleaned up the trash, for a thorough clean, you can vacuum the dust using a vacuum cleaner.`
                      : `Seperti halnya jok mobil, karpet mobil juga menjadi bagian yang sering tercemar noda sisa makanan dan minuman. Nah, setelah kamu bersihkan sampahnya, agar benar-benar bersih, kamu bisa menyedot debunya menggunakan vacuum cleaner.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `When vacuuming the carpet dust, use a soft brush head and lifting motions to remove stubborn stains. Avoid scrubbing the carpet as it can damage the car carpet fibers. Also, make sure to remove the car mats and boot liner as there's usually a lot of dirt underneath them.`
                      : `Saat menyedot debu karpet, gunakan kepala sikat yang lembut dan gerakan mengangkat untuk menghilangkan noda yang membandel. Hindari menggosok karpet karena bisa merusak serat karpet mobil. Dan pastikan kamu melepas matras mobil dan bootliner, karena biasanya banyak kotoran di bawahnya.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section6}>
                <b>
                  <h2 style={{ marginBottom: "20px" }} className="roleway">
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Clean the Car Door Trim`
                      : `Bersihkan Door Trim Mobil`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/QmkY04Y/Door-trim.webp"
                  alt="Coating-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `This Door Trim is better known as the car door panel because it contains various buttons and car features. These features function to enhance safety and comfort while driving, such as adjusting car windows, locking the car, and activating seat belts.`
                      : `Door Trim ini lebih dikenal dengan panel pintu mobil karena terdapat beragam tombol dan fitur mobil. Fitur tersebut berfungsi untuk meningkatkan keamanan dan kenyamanan saat berkendara. Seperti mengatur kaca jendela mobil, mengunci mobil, mengaktifkan sabuk pengaman.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Door trim is one of the interiors prone to dust and dirt. To maintain and protect your door trim from pesky dust, you can use a vacuum cleaner to suction the dust.`
                      : `Door trim menjadi salah satu interior yang rentan dengan debu dan kotoran. Agar door trim kamu terawat dan terhindar dari debu-debu jahat, kamu bisa menggunakan vacuum cleaner untuk menyedot debunya.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Next, clean it using a gentle-textured cleaning tool, and you can also use a nylon-based brush to clean the remaining dirt that sticks.`
                      : `Kemudian, kamu bersihkan menggunakan alat pembersih yang bertekstur lembut, dan bisa juga dengan menggunakan sikat berbahan dasar nilon untuk membersihkan sisa kotoran yang menempel.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Additionally, if you want to use specific soap or liquid, make sure it matches the material of your car door trim. Choosing the wrong soap might actually damage your beloved car door trim.`
                      : `Selain itu, kalo kamu ingin menggunakan sabun atau cairan tertentu, pastikan cairannya sesuai dengan bahan material door trim mobilmu. Karena kalo salah pilih sabun itu justru bisa merusak door trim mobil kesayanganmu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Well, those are the 6 secrets to maintaining the interior of your beloved car to keep it shiny and sparkling. How was it? Quite easy, right?`
                      : `Nah itulah 6 rahasia merawat interior mobil kesayanganmu agar tetap kinclong dan berkilau. Bagaimana, cukup mudah kan?`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Card
            className="bg-dark "
            style={{
              position: "relative",
              overflow: "hidden",
              alignSelf: "center",
            }}
            onClick={() => handleCardClick("/layanan-harga")}
          >
            <LoadingImage
              src="https://i.ibb.co.com/cbtb04c/cleaning-vacum.webp"
              alt="Card image"
              className="card-overlay"
            />
            <Card.ImgOverlay
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "start",
                flexDirection: "column",
                color: "red",
              }}
            >
              <Card.Title>
                <b>Detailing</b>
              </Card.Title>
              <Card.Text
                style={{ backdropFilter: "blur(2px)" }}
                className="nunito"
              >
                {localStorage.getItem("bahasa") === "ing"
                  ? ` Solve your car problem at Wecarcare.`
                  : `Selesaikan masalah mobil mu di Wecarcare`}
              </Card.Text>
            </Card.ImgOverlay>
          </Card>
        </Container>
        <Footer />
      </div>
    </article>
  );
};

export default Article5;
